import { FilesApiBase } from './paymentApi';

class FilesApi extends FilesApiBase {

}

export default new FilesApi();
